import { AddonsType, AutomationsType } from '../types/addons'


export const addons: AddonsType[] = [
  'OPEN_API',
  'SHORTEST_LEAVE_INTERVAL',
  'SYNC_SHARED_CALENDARS',
  'VISIBILITY',
  'NO_LIMIT_TEAMS',
  'NO_LIMIT_LOCATION',
  'MULTI_LEVEL_APPROVAL',
  'NOTIFY_TO_WATCHERS',
  'TOIL',
]

export const automations: AutomationsType[] = [
  'BLACKOUT_PERIOD',
  'SENIORITY_ENTITLEMENT',
  'ENTITLEMENT_BY_ROLE',
  'PROBATION_PERIOD',
  'MAXIMUM_USERS_AWAY',
  'LEAVE_DURATION_LIMIT',
  'LEAVE_REQUEST_NOTICE_PERIOD',
]
